import { ReportKey } from '@models/interfaces';
import { REPORT_TAB_QUERY_PARAM } from './constants';

export const DEFAULT_REPORT_KEY = ReportKey.OverdueTasks;

export const REPORT_TABS = [
  {
    key: ReportKey.OverdueTasks,
    title: 'Overdue Task Tracker',
  },
  {
    key: ReportKey.StructuralPassFail,
    title: 'Structural Pass/Fail',
  },
  {
    key: ReportKey.DatesAtAGlance,
    title: 'Dates at a Glance',
  },
  {
    key: ReportKey.ProjectDuration,
    title: 'Project Duration',
  },
  {
    key: ReportKey.NewClosedProjects,
    title: 'New/Closed Projects',
  },
  { key: ReportKey.PermittingOverview, title: 'Permitting Overview Report' },
  { key: ReportKey.BPExpiration, title: 'BP Expiration Report' },
];

export const getReportKeyFromTabName = (tabName?: string | null): ReportKey =>
  REPORT_TABS.find(({ title }) => title === tabName)?.key ?? DEFAULT_REPORT_KEY;

export const getReportKeyFromSearch = (search: string): ReportKey =>
  getReportKeyFromTabName(
    new URLSearchParams(search).get(REPORT_TAB_QUERY_PARAM),
  );
